/// <reference path="include.ts" />

namespace project_commons {

	jQuery(document).ready((): void => {
		const application = new Application();
		application.run();
	});
}
